import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles } from "@constants/typography"
import { DesktopOnly, MobileAndTabletOnly } from "@utils/MediaQuery"
import React from "react"
import styled, { css } from "styled-components"

export const Container = styled.div<{ fullWidth?: boolean }>`
  ${({ fullWidth }) => css`
    padding: 0 ${fullWidth ? "0" : "20px"} 88px;

    @media ${breakpoints.tablet} {
      padding: 0 ${fullWidth ? "0" : "calc(1 / 12 * 100vw)"} 88px;
    }

    @media ${breakpoints.laptop} {
      padding: 0 ${fullWidth ? "0" : "calc(1 / 12 * 100vw)"} 178px;
    }

    ${ImageHelperContainer} {
      width: 100%;
      height: calc(100vw - 40px);

      @media ${breakpoints.tablet} {
        width: ${fullWidth ? "100vw" : "calc(10 / 12 * 100vw)"};
        height: calc(10 / 12 * 100vw);
      }

      @media ${breakpoints.laptop} {
        width: ${fullWidth ? "100vw" : "calc(10 / 12 * 100vw)"};
        height: calc(10 / 12 * 100vw * 0.51);
      }
    }
  `}
`

const CaptionWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  align-items: center;
`

const Caption = styled.div`
  width: calc(100% - 35px);
  font-family: "Avenir Roman";
  font-size: 15px;
  color: ${colors.black};
  line-height: 22px;
  opacity: 0.3;

  @media ${breakpoints.tablet} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }

  @media ${breakpoints.laptop} {
    ${body14Styles}
    color: ${colors.mediumGray};
    opacity: 1;
  }
`

const Dash = styled.div`
  width: 23px;
  height: 1px;
  margin-right: 12px;
  background-color: ${colors.mediumGray};
`

interface MediaImageProps {
  blockId?: string
  caption?: string
  fullWidth?: boolean
  image: string
  mobileImage?: string
}

const MediaImage: React.FC<MediaImageProps> = ({
  blockId,
  caption,
  fullWidth,
  image,
  mobileImage,
}) => {
  return image ? (
    <Container fullWidth={fullWidth} id={blockId || undefined}>
      <MobileAndTabletOnly>
        <ImageHelper src={mobileImage ? mobileImage : image} />
      </MobileAndTabletOnly>
      <DesktopOnly>
        <ImageHelper src={image} />
      </DesktopOnly>
      {caption && (
        <CaptionWrapper>
          <Dash />
          <Caption>{caption}</Caption>
        </CaptionWrapper>
      )}
    </Container>
  ) : null
}

export default MediaImage
